import { Box, Divider, Flex } from '@chakra-ui/react';
import useOrganisationSettings from 'components/hooks/useOrganisationSettings';

import { AppNavigationOutlined } from 'assets/assetsV1/iconComponents';

import { StringModifier, modifyString } from 'constants/copyHelpers';

import { ListItemComp } from 'uiToolkitV1/ListItemComp';
import { SelectDashed } from 'uiToolkitV1/Select';

const FREQUENCY_OPTIONS = [
  { label: 'Quarterly', value: 'QUARTERLY' },
  { label: 'Half Yearly', value: 'HALF_YEARLY' },
  { label: 'Yearly', value: 'YEARLY' },
];

const START_MONTH_OPTIONS = [
  { label: 'January', value: 'JANUARY' },
  { label: 'February', value: 'FEBRUARY' },
  { label: 'March', value: 'MARCH' },
  { label: 'April', value: 'APRIL' },
  { label: 'May', value: 'MAY' },
  { label: 'June', value: 'JUNE' },
  { label: 'July', value: 'JULY' },
  { label: 'August', value: 'AUGUST' },
  { label: 'September', value: 'SEPTEMBER' },
  { label: 'October', value: 'OCTOBER' },
  { label: 'November', value: 'NOVEMBER' },
  { label: 'December', value: 'DECEMBER' },
];

const GoalFrequency = ({ data, onChange }) => {
  const { moduleName } = useOrganisationSettings();

  return (
    <Box mb="1rem" bgColor="white" padding="2rem" borderRadius="8px">
      <Flex justifyContent="space-between" alignItems="center" mb="1rem">
        <ListItemComp
          withoutBackground
          LeftComponent={AppNavigationOutlined}
          title={`${modifyString(moduleName, StringModifier.PLURAL_TITLE_CASE)} Frequency`}
          subTitle="Choose when goal tracking starts and duration to achieve them"
          p={0}
          px={1}
        />
        {/* <AppNavigationOutlined boxSize={'36px'} />
          <Box style={{ flexGrow: 1 }} ml={'1rem'}>
            <Typography14 style={{ fontWeight: '600' }}>Goals Frequency</Typography14>
            <Typography8>Choose time period frequency for Goals</Typography8>
          </Box> */}
      </Flex>
      <Divider />
      <Box ml="0.5rem">
        {/* <Typography14 style={{ fontWeight: '400', fontSize: '14px', padding: '1rem 0' }}>
            Choose time period frequency for Goals
          </Typography14> */}

        <Flex columnGap={8}>
          <SelectDashed
            handleChange={(data) => {
              onChange('startMonth', data.value);
            }}
            value={START_MONTH_OPTIONS.find((month) => month.value === data?.startMonth)}
            label="Start Month"
            options={START_MONTH_OPTIONS}
            placeholder="Select a Month"
            withBorderBottom
          />
          {/* <StyledSelect
              handleChange={() => {}}
              name="Name"
              options={FREQUENCY_OPTIONS}
              placeholder="2023"
              label="Year"
              withBorderBottom
            /> */}
          <SelectDashed
            handleChange={(data) => {
              onChange('frequencyType', data.value);
            }}
            label="Repeat Frequency"
            value={FREQUENCY_OPTIONS.find((month) => month.value === data?.frequencyType)}
            options={FREQUENCY_OPTIONS}
            placeholder="Select Repeat Frequency"
            withBorderBottom
          />
        </Flex>
      </Box>
    </Box>
  );
};

export default GoalFrequency;
